/**
 * Formats timestamps as pt-BR relative time strings.
 */
const relativeTimeFormat = new Intl.RelativeTimeFormat("pt-BR", {
  numeric: "auto",
});

const UNITS_IN_SECONDS = [
  { unit: "year", seconds: 31_536_000 },
  { unit: "month", seconds: 2_592_000 },
  { unit: "week", seconds: 604_800 },
  { unit: "day", seconds: 86_400 },
  { unit: "hour", seconds: 3_600 },
  { unit: "minute", seconds: 60 },
  { unit: "second", seconds: 1 },
];

export function formatRelativeDate(value) {
  const time = value instanceof Date ? value.getTime() : Number(value);
  if (!Number.isFinite(time)) return "";

  const diffInSeconds = Math.round((time - Date.now()) / 1000);
  const elapsed = Math.abs(diffInSeconds);

  for (const { unit, seconds } of UNITS_IN_SECONDS) {
    if (elapsed >= seconds || unit === "second") {
      return relativeTimeFormat.format(Math.round(diffInSeconds / seconds), unit);
    }
  }

  return "";
}
